const PBR_HAS_NORMAL_MAP = 1 << 0;
const PBR_HAS_EMISSIVE = 1 << 1;
const PBR_HAS_ENV = 1 << 2;
const PBR_HAS_ALPHA_TEST = 1 << 3;
const PBR_HAS_TONEMAP = 1 << 4;
const PBR_HAS_FOG = 1 << 5;
const PBR_HAS_ALPHA_BLEND = 1 << 6;
const PBR_HAS_SPEC_GLOSS = 1 << 7;
const PBR_HAS_DOUBLE_SIDED = 1 << 8;
const PBR_HAS_COTANGENT_NORMAL = 1 << 9;
const PBR_HAS_METALLIC_REFLECTANCE_MAP = 1 << 10;
const PBR_HAS_REFLECTANCE_MAP = 1 << 11;
const PBR_HAS_USE_ALPHA_ONLY_MR = 1 << 12;
const PBR_HAS_OCCLUSION = 1 << 15;
const PBR_HAS_SPECULAR_AA = 1 << 17;
const PBR_HAS_CLEARCOAT = 1 << 20;
const PBR_HAS_EMISSIVE_COLOR = 1 << 21;
const PBR_HAS_SHEEN = 1 << 22;
const PBR_HAS_SHEEN_TEXTURE = 1 << 23;
const PBR_HAS_GAMMA_ALBEDO = 1 << 25;
const PBR_HAS_ANISOTROPY = 1 << 26;
const PBR_HAS_SUBSURFACE = 1 << 27;
const PBR_HAS_THICKNESS_MAP = 1 << 28;
const PBR_HAS_SKYBOX = 1 << 29;
const PBR_HAS_SHEEN_ALBEDO_SCALING = 1 << 30;
const PBR2_HAS_REFRACTION = 1 << 4;
const PBR2_HAS_UV_TRANSFORM = 1 << 9;
const PBR2_HAS_REFLECTANCE_FACTORS = 1 << 10;
const PBR2_HAS_UV2 = 1 << 11;
const PBR2_HAS_BASE_COLOR_FACTOR = 1 << 12;
const PBR2_NO_COLOR_OUTPUT = 1 << 15;
const PBR2_ESM_SHADOW_OUTPUT = 1 << 16;

export { PBR2_ESM_SHADOW_OUTPUT, PBR2_HAS_BASE_COLOR_FACTOR, PBR2_HAS_REFLECTANCE_FACTORS, PBR2_HAS_REFRACTION, PBR2_HAS_UV2, PBR2_HAS_UV_TRANSFORM, PBR2_NO_COLOR_OUTPUT, PBR_HAS_ALPHA_BLEND, PBR_HAS_ALPHA_TEST, PBR_HAS_ANISOTROPY, PBR_HAS_CLEARCOAT, PBR_HAS_COTANGENT_NORMAL, PBR_HAS_DOUBLE_SIDED, PBR_HAS_EMISSIVE, PBR_HAS_EMISSIVE_COLOR, PBR_HAS_ENV, PBR_HAS_FOG, PBR_HAS_GAMMA_ALBEDO, PBR_HAS_METALLIC_REFLECTANCE_MAP, PBR_HAS_NORMAL_MAP, PBR_HAS_OCCLUSION, PBR_HAS_REFLECTANCE_MAP, PBR_HAS_SHEEN, PBR_HAS_SHEEN_ALBEDO_SCALING, PBR_HAS_SHEEN_TEXTURE, PBR_HAS_SKYBOX, PBR_HAS_SPECULAR_AA, PBR_HAS_SPEC_GLOSS, PBR_HAS_SUBSURFACE, PBR_HAS_THICKNESS_MAP, PBR_HAS_TONEMAP, PBR_HAS_USE_ALPHA_ONLY_MR };
//# sourceMappingURL=pbr-flag-bits.js.map
